module.exports = __webpack_public_path__ + "client/projects/assets/dogtown-media/dogtown-news-tabs.png";


//////////////////
// WEBPACK FOOTER
// ./client/projects/assets/dogtown-media/dogtown-news-tabs.png
// module id = 271
// module chunks = 0